import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { GridLayout } from 'components/form/layout';
import Dropdown from 'components/Dropdown';
import Title from 'components/Title';
import { PercentageFloatField, TextField, IntegerField } from 'components/form/field';
import sortSettings from 'common/utils/sortSettings';
import { DELETE } from 'utils/httpMethods';
import SupportRepartition from '../lifeInsurance/SupportRepartition/SupportRepartition';
import BusinessPartnerSubscriptionField from '../businessPartner/BusinessPartnerSubscriptionField';

const PerDropdown = ({ deleted, baseProducts, businessPartners, name, type }) => {
    const deleteSetting = useCallback(async (e) => {
        e.preventDefault();
        if (window.confirm('Supprimer le contrat ?')) {
            await DELETE(`/api/settings/simulation.per.contracts.${type}`);
            window.location.reload(true);
        }
    }, []);

    return (
        <Dropdown title={`${deleted ? '(supprimé) ' : ''}${name}`} key={type}>
            <GridLayout className="double condensed full-width" key={type}>
                <TextField
                    name={`simulation.per.contracts.${type}.name`}
                    title="Nom"
                />
                <PercentageFloatField
                    name={`simulation.per.contracts.${type}.fees.min`}
                    title="Frais d'entrée min"
                />
                <PercentageFloatField
                    name={`simulation.per.contracts.${type}.fees.max`}
                    title="Frais d'entrée max"
                />
                <IntegerField
                    name={`simulation.per.contracts.${type}.miniInitialFunding`}
                    title="Minimum versement initial"
                />
                <IntegerField
                    name={`simulation.per.contracts.${type}.miniScheduledPaymentAmount`}
                    title="Minimum versement programmé"
                />
                <TextField
                    name={`simulation.per.contracts.${type}.codeApporteur`}
                    title="Code apporteur"
                />
            </GridLayout>
            {['P', 'E', 'D'].map((profile) => (
                <GridLayout key={profile} className="condensed full-width">
                    <SupportRepartition
                        baseProducts={baseProducts}
                        baseName={`simulation.per.contracts.${type}.`}
                        profile={profile}
                    />
                </GridLayout>
            ))}
            <Title><b>Partenaire</b></Title>
            <BusinessPartnerSubscriptionField
                name={`simulation.per.contracts.${type}.subscription`}
                businessPartners={businessPartners}
            />
            <hr />
            <button className="theseis-btn" onClick={deleteSetting}>Supprimer le contrat</button>
        </Dropdown>
    );
};

PerDropdown.propTypes = {
    baseProducts: PropTypes.shape({}).isRequired,
    businessPartners: PropTypes.shape({}).isRequired,
    deleted: PropTypes.bool,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
};

const PerContract = ({ baseProducts, businessPartners, types }) => sortSettings(types)
    .map(([type, contract]) => (
        <PerDropdown
            baseProducts={baseProducts}
            businessPartners={businessPartners}
            type={type}
            key={type}
            {...contract}
        />
    ));

PerContract.propTypes = {
    baseProducts: PropTypes.shape({}).isRequired,
    businessPartners: PropTypes.shape({}).isRequired,
    types: PropTypes.shape({}).isRequired,
};

export default PerContract;
